import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ProgressBarHoc from 'containers/Async/AsyncProgressBar'

import CSSModules from 'helpers/CSSModulesUtil'

import {
  FETCH_PROJECT_LIST,
  FETCH_PROJECT_FILTERS,
} from 'containers/Project/ElasticSearch/constants'

import styles from './styles.scss'

const ProgressBar = ProgressBarHoc([FETCH_PROJECT_LIST, FETCH_PROJECT_FILTERS])

const ProgressBarComponent = props => {
  return (
    <div styleName='progressBarContainer'>
      <ProgressBar/>
    </div>
  )
}

const withStyle = CSSModules(styles)
export default withStyle(ProgressBarComponent)

